import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback } from 'react';
import { InputGroup, InputLeftElement, InputRightElement } from '@chakra-ui/react';
import { ClearInputButton } from '../../ClearInputButton/component.js';
import { ShowHidePasswordButton } from '../../ShowHidePasswordButton/component.js';
import { Icon } from '../../Icon/component.js';
import { Layout } from '../../Layout/component.js';
var _excluded = ["leftAddOn", "rightAddOn", "clearField", "icon", "type", "showPassword", "ref", "onChange", "toggleShowPassword", "isReadOnly"];
function withInputAddons(componentName) {
  return function (WrappedInput) {
    var ComponentWithInputAddons = function ComponentWithInputAddons(props) {
      var leftAddOn = props.leftAddOn,
        rightAddOn = props.rightAddOn,
        clearField = props.clearField;
      props.icon;
      var type = props.type,
        showPassword = props.showPassword;
      props.ref;
      var onChange = props.onChange,
        toggleShowPassword = props.toggleShowPassword,
        isReadOnly = props.isReadOnly,
        rest = _objectWithoutProperties(props, _excluded);
      var inputRef = React.useRef(null);
      var _useState = useState(rest.value),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];
      var handleChange = useCallback(function (event) {
        onChange === null || onChange === void 0 || onChange(event); // ensure input's original onChange gets called too
        setValue(event.target.value);
      }, [onChange]);
      var handleClearField = useCallback(function () {
        clearField === null || clearField === void 0 || clearField();
        setValue('');
      }, [clearField]);
      return /*#__PURE__*/React.createElement(InputGroup, null, (leftAddOn || type === 'search') && /*#__PURE__*/React.createElement(InputLeftElement, {
        marginLeft: "4"
      }, leftAddOn, type === 'search' && /*#__PURE__*/React.createElement(Icon, {
        iconName: "search",
        prefix: "fas",
        size: "sm"
      })), /*#__PURE__*/React.createElement(WrappedInput, _extends({
        type: type,
        ref: inputRef,
        onChange: handleChange
      }, rest, {
        css: !value && type === 'date' && 'padding-inline-end: 4px'
      })), /*#__PURE__*/React.createElement(InputRightElement, null, /*#__PURE__*/React.createElement(Layout, {
        variant: "flex",
        alignContent: "center"
      }, /*#__PURE__*/React.createElement(Layout, null, value && value !== '' && !isReadOnly && /*#__PURE__*/React.createElement(ClearInputButton, {
        clearField: handleClearField,
        inputRef: inputRef
      })), rightAddOn && /*#__PURE__*/React.createElement(Layout, {
        alignSelf: "center",
        marginRight: "2"
      }, rightAddOn), toggleShowPassword && showPassword !== undefined && /*#__PURE__*/React.createElement(ShowHidePasswordButton, {
        toggleShowPassword: toggleShowPassword,
        showPassword: showPassword
      }))));
    };
    ComponentWithInputAddons.displayName = componentName;
    return ComponentWithInputAddons;
  };
}
export { withInputAddons };